import { CSS as ModalCSS } from '../../components/modal/modal.style';
import { DefaultTheme } from '../../components/theme';
import { ColorPalette2022Branding } from '../../components/theme.palette';

export const CSS = {
	modal: 'c-ReleaseNotesModal',
	release: 'c-ReleaseNotesModal__release',
	releaseHeading: 'c-ReleaseNotesModal__release-heading',
	releaseDescription: 'c-ReleaseNotesModal__release-description',
	section: 'c-ReleaseNotesModal__section',
	sectionHeading: 'c-ReleaseNotesModal__section-heading',
	sectionList: 'c-ReleaseNotesModal__section-list',
	sectionItem: 'c-ReleaseNotesModal__section-item',
	allReleaseNotes: 'c-ReleaseNotesModal__all-release-notes',
};

export const Style = {
	[CSS.modal]: {
		width: '800px',
		'max-width': '90vw',
		'max-height': '80vh',
	},
	[`${CSS.modal} .${ModalCSS.title}`]: {
		'background-color': DefaultTheme.background.offWhite,
		color: DefaultTheme.font.color.primary,
		'border-bottom': `1px solid ${DefaultTheme.font.color.divider}`,
		'font-weight': 'bold',
	},
	[CSS.release]: {
		'padding-bottom': DefaultTheme.space(4),
	},
	[CSS.releaseHeading]: {
		'font-size': DefaultTheme.font.size * 1.1 + 'px',
		'font-weight': 'bold',
		color: DefaultTheme.font.color.primary,
		'padding-bottom': DefaultTheme.space(2),
		'margin-bottom': DefaultTheme.space(3),
		'border-bottom': `1px solid ${DefaultTheme.font.color.divider}`,
	},
	[CSS.releaseDescription]: {
		color: DefaultTheme.font.color.supporting,
		'margin-bottom': DefaultTheme.space(2),
	},
	[CSS.section]: {
		'margin-top': DefaultTheme.space(3),
	},
	[CSS.sectionHeading]: {
		'font-weight': 'bold',
		color: DefaultTheme.font.color.primary,
		'margin-bottom': DefaultTheme.space(1),
	},
	[CSS.sectionList]: {
		margin: `${DefaultTheme.space(1)} 0 0 0`,
		'padding-left': DefaultTheme.space(5),
	},
	[CSS.sectionItem]: {
		'margin-bottom': DefaultTheme.space(1),
		'line-height': 1.4,
	},
	[CSS.allReleaseNotes]: {
		display: 'block',
		'text-align': 'center',
		'margin-top': DefaultTheme.space(4),
		padding: DefaultTheme.space(2),
		color: ColorPalette2022Branding.ikeOrange,
		'text-decoration': 'none',
		'font-weight': 'bold',
		'&:hover': {
			'text-decoration': 'underline',
		},
	},
};
